import styled from 'styled-components';

const Container = styled.div`
   padding: 0 10px;
   min-width: 330px;
   color: ${({ theme }) => theme.secondaryWhite};
   max-width: 600px;
   position: relative;
   margin: ${({ margin = '4em auto' }: { margin?: string }) => margin};

   @media only screen and (min-width: 1000px) {
      width: 70%;
   }

   @media only screen and (max-width: 400px) {
      margin: 1em auto;
      width: 85%;
   }
`;

export default Container;
